// extracted by mini-css-extract-plugin
export var addressFields = "_me-0";
export var animationContainer = "_me-1";
export var footer = "_me-2";
export var lineItems = "_me-3";
export var modalContent = "_me-4";
export var orderName = "_me-5";
export var strong = "_me-6";
export var warning = "_me-7";